import { render, staticRenderFns } from "./FollowingProductionTasks.vue?vue&type=template&id=16d90788&scoped=true&"
import script from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d90788",
  null
  
)

export default component.exports